<script>
// AdvancedMarkerElement replacement for vue-googlemaps' legacy Marker.
export default {
  name: "AdvancedMapMarker",
  props: {
    position: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    icon: {
      default: null,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  render: function() {
    return null;
  },
  mounted: function() {
    this.init();
  },
  beforeDestroy: function() {
    if (this.$_marker && this.$_clickHandler) {
      this.$_marker.removeEventListener("gmp-click", this.$_clickHandler);
    }
    if (this.$_marker) {
      this.$_marker.map = null;
      this.$_marker = null;
    }
  },
  watch: {
    position: {
      deep: true,
      handler: function(pos) {
        if (this.$_marker && pos) {
          this.$_marker.position = pos;
        }
      },
    },
    icon: function() {
      this.updateContent();
    },
    title: function(title) {
      if (this.$_marker) {
        this.$_marker.title = title;
      }
    },
  },
  methods: {
    findMapComponent: function() {
      var search = this.$parent;
      while (search) {
        if (search.$options.name === "GoogleMapsMap") {
          return search;
        }
        search = search.$parent;
      }
      return null;
    },
    buildIconContent: function() {
      var icon = this.icon;
      if (!icon) {
        return null;
      }
      var url = typeof icon === "string" ? icon : icon.url;
      if (!url) {
        return null;
      }
      var img = document.createElement("img");
      img.src = url;
      img.alt = this.title || "";
      var size = icon.scaledSize || icon.size;
      if (size) {
        img.style.width = (size.width || 30) + "px";
        img.style.height = (size.height || 35) + "px";
      }
      return img;
    },
    updateContent: function() {
      if (this.$_marker) {
        this.$_marker.content = this.buildIconContent();
      }
    },
    init: function() {
      var self = this;
      var mapComp = this.findMapComponent();
      if (!mapComp) {
        return;
      }

      mapComp.$_getMap().then(function() {
        return window.google.maps.importLibrary("marker");
      }).then(function(lib) {
        self.$_marker = new lib.AdvancedMarkerElement({
          map: mapComp.$_map,
          position: self.position,
          title: self.title,
          content: self.buildIconContent(),
          gmpClickable: self.clickable,
        });

        if (self.clickable) {
          self.$_clickHandler = function() {
            self.$emit("click");
          };
          self.$_marker.addEventListener("gmp-click", self.$_clickHandler);
        }
      });
    },
  },
};
</script>
